import classNames from 'classnames'
import toast from 'cogo-toast'
import { UserForTag, UserForTagVariables } from 'globalTypes'
import md5 from 'js-md5'

import { useQuery } from '@apollo/client'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import styles from './index.module.css'
import QUERY from './user-for-tag.graphql'

library.add(faTimes)

const pictureByEmail = (email: string) =>
  `https://www.gravatar.com/avatar/${md5(email)}?s=40&d=${encodeURIComponent(
    `https://eu.ui-avatars.com/api/${email}/40/f3f4f6/6b7280/1/0.6/false/true/true/png`
  )}`

const Tag = ({
  disabled,
  getTagDisplayValue,
  index,
  onRemove,
  tag,
  creator,
  isValid = true,
}: any) => {
  const { i18n } = useLingui()

  const truncate = (s: string | undefined | null, n = 30) => {
    if (!s) return ''
    return s.length > n ? `${s.slice(0, n - 3)}...` : s
  }

  const { data, loading } = useQuery<UserForTag, UserForTagVariables>(QUERY, {
    variables: {
      identifier: tag,
    },
    onCompleted(data) {
      // checks if the user is trying to add themselves as a tag to prevent self invitations
      if (data?.user?.id === creator.id) {
        toast.warn(
          t(
            i18n
          )`Nessuna email verrà inviata a ${data?.user?.name} perchè è il creatore di questo elemento.`
        )
      }
    },
  })

  return (
    <span
      className={classNames(styles.container, { [styles.invalid]: !isValid })}
      key={tag}
    >
      {loading ? (
        <div
          className={classNames(styles.pictureLoading, 'animate-pulse')}
        ></div>
      ) : (
        <img
          alt={data?.user?.name || getTagDisplayValue(tag)}
          className={styles.picture}
          src={data?.user?.picture || pictureByEmail(tag)}
        />
      )}
      <span>{truncate(data?.user?.name || getTagDisplayValue(tag))}</span>
      {!disabled && (
        <button
          className={styles.button}
          onClick={() => onRemove(index)}
          type="button"
        >
          <FontAwesomeIcon className={styles.icon} icon={['fas', 'times']} />
        </button>
      )}
    </span>
  )
}

export default Tag
